import React from "react";

import { Grid35 } from "site/src/components/css";

var formatCurrency = require("../utils/formatter").formatCurrency;
var formatCurrencyGLA = require("../utils/formatter").formatCurrencyGLA;
var formatGLA = require("../utils/formatter").formatGLA;

var priceRange = require("../utils/priceGlaData").priceRange;
var glaRange = require("../utils/priceGlaData").glaRange;

function PropertyTitle({ property, deal, type }) {

  //Deal specific data
  var PropertyHeader = () => {

    if (deal === "ToLet" && type === "property") {
      return (

        <Grid35>

          <h1>{property[0].property_name}</h1>

          <div className="titleData">
            <h4 className="preTitle">GLA</h4><h3>{formatGLA(glaRange(property).gla_1, glaRange(property).gla_2)}</h3>
          </div>

          <div className="titleData">
            <h4 className="preTitle">Price</h4><h3>{formatCurrencyGLA(priceRange(property).gross_price_1, priceRange(property).gross_price_2)}</h3>
          </div>

        </Grid35>

      )
    }

    if (deal === "ToLet" && type === "property_unit") {
      return (

        <Grid35>

          <h1>{property[0].property_name}</h1>
          {/* <h5><Link to={makePropertyPagePath(property[0], "ToLet", "property")}>You are viewing a property unit - click to view parent property</Link></h5> */}

          <div className="titleData">
            <h4 className="preTitle">Price</h4><h3>{formatCurrencyGLA(priceRange(property).gross_price_1, priceRange(property).gross_price_2)}</h3>
          </div>

          <div className="titleData">
            <h4 className="preTitle">GLA</h4><h3>{formatGLA(glaRange(property).gla_1, glaRange(property).gla_2)}</h3>
          </div>

        </Grid35>

      )
    }

    if (deal === "ForSale" && type === "property") {
      return (

        <Grid35>

          <h1>{property[0].property_name}</h1>

          <div className="titleData">
            <h4 className="preTitle">Price</h4><h3>{formatCurrency(priceRange(property).gross_price_1)}</h3>
          </div>

          <div className="titleData">
            <h4 className="preTitle">GLA</h4><h3>{formatGLA(glaRange(property).gla_1)}</h3>
          </div>

        </Grid35>

      )
    }

    if (deal === "ForSale" && type === "property_unit") {
      return (

        <Grid35>

          <h1>{property[0].property_name}</h1>

          <div className="titleData">
            <h4 className="preTitle">Price</h4><h3>{formatCurrency(priceRange(property).gross_price_1)}</h3>
          </div>

          <div className="titleData">
            <h4 className="preTitle">GLA</h4><h3>{formatGLA(glaRange(property).gla_1)}</h3>
          </div>

        </Grid35>

      )
    }

  }

  return (
    <div>

      <PropertyHeader />

    </div>
  )
}

export default PropertyTitle;